export enum EnumSubtipoCiclo {
  AsociadoDistribucion = 1,
  FechaInicioFechaFin,
  Compra,
  Venta,
  CompraVenta,
  Facturas,
  AltasBajasRenovaciones,
  Trades,
  Gasineras,
  AsociadoDistribucionDesagregada
}
